module.exports = __webpack_public_path__ + "img/90501245.5e9ec109.png";